import { transform, isString } from 'lodash';

/**
 * // TODO: перенести типы в lt/open-api, когда структура будет соотвествовать room_info в актуализации
 * @see https://leveltravel.atlassian.net/browse/LT-23934
 */

// Images
type ImagePath = { url: string };
type ImageSizes = 'x100x110' | 'x150x110' | 'x260x150' | 'x900x380' | 'x900';
type ImageSizesMap = Record<ImageSizes, ImagePath>;
type TransformedImage = Record<ImageSizes, string>;

type File = ImageSizesMap & ImagePath;
interface Image {
  id: number;
  file: File | string;
  hotel_room_id: number;
  hotel_id?: any;
  created_at: Date;
  updated_at: Date;
}

interface HotelRoomFacilityType {
  id: number;
  created_at: Date;
  updated_at: Date;
  name: string;
}

export interface RoomInfo {
  id: number;
  hotel_id: number;
  room_type_id: number;
  created_at: Date;
  updated_at: Date;
  count?: any;
  accommodation: string;
  view?: any;
  area: number;
  main_image_id: number;
  description: string;
  name_ru: string;
  name_en: string;
  hotel_room_facility_types: HotelRoomFacilityType[];
  images: Image[];
}

/**
 * Преобразуем массив изображений оффера на чекауте
 */
export const transformRoomInfo = (roomInfo: RoomInfo) => ({
  ...roomInfo,
  images: Array.isArray(roomInfo.images)
    ? roomInfo.images.map(({ id, file = {} }) => {
        const obj = transform(
          file,
          (result: TransformedImage, value: File | string, key: ImageSizes) => {
            result[key] = isString(value) ? value : value.url;
            return result;
          },
        );

        return {
          id,
          ...obj,
        };
      })
    : null,
});
